import { useMutation } from '@tanstack/react-query'

import { generateMoreLikeThisVariants } from '../api'

const useMoreLikeThisVariantsMutation = () => {
  return useMutation(generateMoreLikeThisVariants)
}

export default useMoreLikeThisVariantsMutation
